import { render } from "./Inventory_InternalTransfer_Dialog.vue?vue&type=template&id=486bb030&scoped=true&ts=true"
import script from "./Inventory_InternalTransfer_Dialog.vue?vue&type=script&lang=ts"
export * from "./Inventory_InternalTransfer_Dialog.vue?vue&type=script&lang=ts"

import "./Inventory_InternalTransfer_Dialog.vue?vue&type=style&index=0&id=486bb030&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core-Abudari\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-486bb030"]])

export default __exports__